const formatDate = (isoString) => {
    if (!isoString)
        return '';
    const date = new Date(isoString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
};
const parseDateFromString = (value) => {
    const [year, month, day] = value.split('-').map(Number);
    return new Date(year, month - 1, day);
};
function buildTextFieldsFromDocument(document, fields) {
    const textFields = [];
    Object.keys(document.value).forEach(field => {
        if (fields.includes(field)) {
            Object.entries(document.value[field]).forEach(([lang, text]) => {
                textFields.push({
                    key: field,
                    languageCode: lang,
                    value: text
                });
            });
        }
    });
    return textFields;
}
function validateData(languageJson, fields, document) {
    const errors = [];
    languageJson.forEach(lang => {
        if (!lang.required)
            return;
        fields.forEach(field => {
            if (!document.value[field]?.[lang.lang_code]) {
                errors.push(`<b>${field} in ${lang.name}</b>`);
            }
        });
    });
    return errors;
}
function initializeDocument(fields, langs) {
    const document = {};
    fields.forEach(field => {
        document[field] = {};
        langs.value.forEach(lang => {
            document[field][lang.lang_code] = '';
        });
    });
    return document;
}
export { formatDate, parseDateFromString, buildTextFieldsFromDocument, validateData, initializeDocument };
